<template>
  <div class="infoSure">
    <div class="content">
      <div class="title">考生信息确认</div>
      <div class="student">
        <div class="imgBox">
          <div class="infoList">
            <div class="infoItem">
              <div class="infoLabel">考生姓名:</div>
              <div class="infoVal">{{ user.name }}</div>
            </div>
            <div class="infoItem">
              <div class="infoLabel">身份证:</div>
              <div class="infoVal">{{ user.idCard }}</div>
            </div>
            <div class="infoItem">
              <div class="infoLabel">准考证:</div>
              <div class="infoVal">{{ user.admissionTicketId }}</div>
            </div>
            <div class="infoItem">
              <div class="infoLabel">性别:</div>
              <div class="infoVal">{{ user.sex == 1 ? "男" : "女" }}</div>
            </div>
            <div class="btn" @click="submitInfo">我已核对并确认无误</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookies";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    this.user = getCookie("userInfo");
  },
  methods: {
    submitInfo() {
      this.$router.push("/exam/examCenter");
    },
  },
};
</script>

<style scoped lang="scss">
.infoSure {
  background-color: #f5f7fa;
  padding: 40px 0;
  box-sizing: border-box;
  height: 100vh;
  .content {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    background-color: #fff;
    .title {
      line-height: 60px;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      padding-left: 30px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8ebf2;
    }
    .student {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: calc(100% - 60px);
      .imgBox {
        background: url(../../assets/exam/info.png) no-repeat;
        background-size: 100% 100%;
        width: 440px;
        height: 494px;
        padding: 0 10px;
        box-sizing: border-box;
        .infoList {
          background: #fff;
          width: 420px;
          height: 334px;
          margin-top: 150px;
          padding: 60px 50px 0;
          box-sizing: border-box;
          .infoItem {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
            font-weight: normal;
            color: #666666;
            margin-bottom: 16px;
            .infoVal {
              color: #333;
            }
          }
          .btn {
            width: 180px;
            line-height: 40px;
            background: #3671bf;
            border-radius: 4px 4px 4px 4px;
            cursor: pointer;
            text-align: center;
            margin: 34px auto 0;
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
